module.exports = __webpack_public_path__ + "images/mdj/members/common/doc-check-744e88d45c5bda60668fae4cdaacebab.png";